module.exports = __webpack_public_path__ + "assets/img/middle.06f6d52b.svg";